import { Slider, SliderOwnProps, Stack, SxProps, Theme, Typography, useTheme } from '@mui/material'
import { Mark } from '@mui/material/Slider/useSlider.types'
import { FC, FocusEventHandler } from 'react'

type Props = {
    id?: string
    name?: string
    value: number | number[]
    marks?: boolean | Mark[]
    step?: number
    min?: number
    max?: number
    onBlur?: FocusEventHandler<HTMLSpanElement>
    onChange?: SliderOwnProps['onChange']
    sx?: SxProps<Theme>
    disabled?: boolean
}

export const SettingsSlider: FC<Props> = ({
    id,
    name,
    value,
    marks,
    step,
    min,
    max,
    onBlur,
    onChange,
    sx,
    disabled,
}) => {
    const { breakpoints } = useTheme()

    return (
        <Stack direction="row" gap={2} sx={sx}>
            <Typography
                variant="body2"
                sx={{
                    width: '56px',
                    height: '32px',
                    border: '1px solid #E7E8EE',
                    borderRadius: '31px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                {value}
            </Typography>
            <Slider
                id={id}
                name={name}
                aria-label={name}
                marks={marks}
                value={value}
                disabled={disabled}
                valueLabelDisplay="auto"
                step={step}
                sx={{
                    width: '72%',
                    [breakpoints.down('sm')]: {
                        width: '67%',
                    },
                }}
                min={min}
                max={max}
                onBlur={onBlur}
                onChange={onChange}
            />
        </Stack>
    )
}
